import { memo, useMemo, type MouseEvent } from "react";

import { useCartLine } from "@shopify/hydrogen-react";

import { CartProductGiftUnassignedItemsView } from "./CartProductGiftUnassignedItems.view";

type Props = {
  buttonLabel?: string;
  handleOpenGiftWithPurchaseDrawer: (e: MouseEvent<HTMLElement>) => void;
  handlePreloadProduct: (e: MouseEvent<HTMLElement>) => void;
};

const CartProductGiftUnassignedItemsBase = ({
  buttonLabel,
  handleOpenGiftWithPurchaseDrawer,
  handlePreloadProduct,
}: Props) => {
  const {
    merchandise,
    quantity: itemQuantity,
    selectedGiftsWithPurchase,
  } = useCartLine();

  const unselectedGiftWithPurchaseQuantity = useMemo(
    () => (itemQuantity ?? 0) - (selectedGiftsWithPurchase?.length ?? 0),
    [itemQuantity, selectedGiftsWithPurchase?.length]
  );

  return (
    <CartProductGiftUnassignedItemsView
      buttonLabel={buttonLabel}
      handleOpenGiftWithPurchaseDrawer={handleOpenGiftWithPurchaseDrawer}
      handlePreloadProduct={handlePreloadProduct}
      itemQuantity={itemQuantity}
      merchandise={merchandise}
      selectedGiftsWithPurchase={selectedGiftsWithPurchase}
      unselectedGiftWithPurchaseQuantity={unselectedGiftWithPurchaseQuantity}
    />
  );
};

export const CartProductGiftUnassignedItems = memo(
  CartProductGiftUnassignedItemsBase
);
